import "core-js/modules/es.parse-float.js";
export var mapSerieData = function mapSerieData(data) {
  var dataMap = [];
  for (var i = 0; i < data.length; i++) {
    dataMap.push([Date.parse(data[i].datetime), parseFloat(data[i].price)]);
  }
  return dataMap;
};